(() => {
  'use strict';
  if (customElements.get('pb15-product')) return;
  class Pb15Product extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      try { this.state = JSON.parse(this.querySelector('[data-product-state]').textContent); } catch (_) { return; }
      this.ready = true;
      this.busy = false;
      this.uncertain = false;
      this.form = this.querySelector('form');
      this.deliveryDetails = this.querySelector('[data-delivery-details]');
      this.defaultDeliveryDetails = this.querySelector('[data-delivery-default]')?.innerHTML || '';
      this.current = this.state.variants.find(v => String(v.id) === String(this.state.variantId)) || this.state.variants[0];
      this.querySelector('[data-variant-id]').disabled = false;
      this.onChange = event => {
        if (!event.target.matches('[data-option]') || this.busy) return;
        const values = [...this.querySelectorAll('[data-option-group]')].map(group => group.querySelector('input:checked')?.value);
        this.selectVariant(this.state.variants.find(v => v.options.every((value, i) => value === values[i])), true);
      };
      this.onClick = event => {
        const gallery = event.target.closest('[data-gallery]');
        if (gallery) this.showGallery(gallery.dataset.gallery);
        if (event.target.closest('[data-zoom]')) this.openZoom();
        const step = event.target.closest('[data-gallery-step]');
        if (step) this.stepGallery(Number(step.dataset.galleryStep));
        const close = event.target.closest('[data-close]');
        if (close) close.closest('dialog').close();
        if (event.target.matches('dialog')) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      };
      this.onKey = event => {
        if (!event.target.closest('.pb15-pdp__gallery') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.stepGallery(event.key === 'ArrowRight' ? 1 : -1);
      };
      this.onPointerDown = event => {
        this.gesture = event.target.closest('button') || event.pointerType === 'mouse' ? null : { x:event.clientX, y:event.clientY, id:event.pointerId };
      };
      this.onPointerUp = event => {
        if (!this.gesture || this.gesture.id !== event.pointerId) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.6) this.stepGallery(dx < 0 ? 1 : -1);
      };
      this.onPointerCancel = () => { this.gesture = null; };
      this.onSubmit = this.submit.bind(this);
      this.onHistory = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.state.variants.find(v => String(v.id) === id) || this.state.variants.find(v => v.available) || this.state.variants[0];
        if (this.busy) { this.queuedHistory = variant; return; }
        this.selectVariant(variant, false);
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      const stage = this.querySelector('[data-stage]');
      stage.addEventListener('pointerdown', this.onPointerDown);
      stage.addEventListener('pointerup', this.onPointerUp);
      stage.addEventListener('pointercancel', this.onPointerCancel);
      this.form.addEventListener('submit', this.onSubmit);
      this.stickyObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.querySelector('[data-sticky-buy]').hidden = entry.isIntersecting;
      }, { threshold:0 });
      this.stickyObserver.observe(this.querySelector('[data-add]'));
      window.addEventListener('popstate', this.onHistory);
      this.initializeGallery();
      this.selectVariant(this.current, false);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      const stage = this.querySelector('[data-stage]');
      stage?.removeEventListener('pointerdown', this.onPointerDown);
      stage?.removeEventListener('pointerup', this.onPointerUp);
      stage?.removeEventListener('pointercancel', this.onPointerCancel);
      this.stickyObserver?.disconnect();
      this.form?.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('popstate', this.onHistory);
      this.ready = false;
    }
    controls() {
      const button = this.querySelector('[data-add]');
      button.disabled = this.busy || this.uncertain || !this.current?.available;
      const label = this.state.copy[this.busy ? 'adding' : this.current?.available ? 'add' : this.current ? 'sold_out' : 'unavailable'];
      this.querySelector('[data-add-label]').textContent = label;
      this.querySelector('[data-sticky-add]').disabled = button.disabled;
      this.querySelector('[data-sticky-add]').setAttribute('aria-busy', String(this.busy));
      this.querySelector('[data-sticky-add-label]').textContent = label;
      this.querySelectorAll('[data-option]').forEach(input => {
        const index = Number(input.dataset.option);
        const options = [...this.current.options];
        options[index] = input.value;
        const match = this.state.variants.find(v => v.options.every((value, i) => value === options[i]));
        input.disabled = this.busy || !match;
        input.closest('label').dataset.available = String(Boolean(match?.available));
      });
    }
    selectVariant(variant, push) {
      if (!variant) { this.feedback(this.state.copy.unavailable, true); return; }
      const previous = this.current;
      const updateGallery = true;
      this.current = variant;
      this.querySelector('[data-variant-id]').value = variant.id;
      const money = variant.money.replace(/<[^>]*>/g, '');
      this.querySelector('[data-price]').textContent = money;
      this.querySelector('[data-sticky-price]').textContent = money;
      const selection = variant.options.join(' · ');
      this.querySelector('[data-selection]').textContent = selection;
      this.querySelector('[data-sticky-selection]').textContent = selection;
      this.querySelector('[data-frame-note]').textContent = this.state.copy[variant.options[1].includes('Utan') ? 'frame_none' : 'frame_included'];
      if(this.deliveryDetails){ if(this.state.coffeeDelivery && String(variant.id)==='55717504123222'){this.deliveryDetails.textContent=this.state.coffeeDelivery;}else{this.deliveryDetails.innerHTML=this.defaultDeliveryDetails;} }
      this.querySelectorAll('[data-delivery]').forEach(node => { node.textContent = this.state.coffeeDelivery && String(variant.id) === '55717504123222' ? this.state.coffeeDelivery : this.state.copy[variant.options[1].includes('Utan') ? 'delivery_unframed' : 'delivery_framed']; });
      this.querySelectorAll('[data-shipping]').forEach(node => { node.textContent = this.state.copy.shipping_free; });
      this.querySelectorAll('[data-option]').forEach(input => { input.checked = input.value === variant.options[Number(input.dataset.option)]; });
      const guideParams = new URLSearchParams({ motiv:this.state.handle, variant:String(variant.id) });
      this.querySelectorAll('[data-size-guide]').forEach(link => { link.href = this.state.guideUrl + '?' + guideParams.toString(); });
      if (!this.busy && !this.uncertain) this.querySelector('[data-feedback]').hidden = true;
      if (push && /^https?:$/.test(location.protocol)) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('option_values');
        if (url.href !== location.href) history.replaceState(history.state, '', url.href);
      }
      this.controls();
      this.syncVariantGallery(variant, updateGallery, previous);
      this.galleryVariantId = variant.id;
      this.dispatchEvent(new CustomEvent('pb15:variant-change', { bubbles:true, detail:{ variant } }));
    }
    initializeGallery() {
      const artworkIds = new Set(this.state.variants.map(variant => String(variant.artMediaId || '')));
      this.galleryItems = [...this.querySelectorAll('[data-view]')].map(panel => {
        const id = panel.dataset.mediaId;
        const alt = panel.dataset.mediaAlt || this.state.title;
        const text = `${alt} ${panel.dataset.zoomUrl || ''}`.toLocaleLowerCase('sv');
        let role = 'image';
        if (panel.dataset.galleryKind === 'size-guide') role = 'size-guide';
        else if (/närbild|close[ -]?up|[-_]detail[_.-]/.test(text)) role = 'detail';
        else if (/svart träram|black (?:wood )?frame|[-_]hero[_.-]/.test(text)) role = 'black';
        else if (/ljus träram|natural (?:wood )?frame|[-_]light[_.-]/.test(text)) role = 'wood';
        else if (/utan ram|originalmotiv|exakta?\s+(?:motiv)?utsnitt|unframed|[-_](?:art|flat|original)[_.-]/.test(text) || artworkIds.has(id)) role = 'original';
        const size = text.match(/(?:^|[^\d])(30|50|70)\s*[x×]\s*(40|70|100)(?:[^\d]|$)/);
        panel.dataset.galleryRole = role;
        return { id, view:panel.dataset.view, role, size:size ? `${size[1]}x${size[2]}` : '', alt, panel, button:this.querySelector(`[data-gallery="${panel.dataset.view}"]`) };
      });
      const roles = ['black', 'original', 'wood', 'detail', 'image', 'size-guide'];
      this.galleryItems.sort((a, b) => roles.indexOf(a.role) - roles.indexOf(b.role));
      const thumbnails = this.querySelector('.pb15-pdp__thumbs');
      if (thumbnails) this.galleryItems.forEach(item => { if (item.button) thumbnails.append(item.button); });
    }
    galleryViews() {
      return (this.galleryItems || []).filter(item => item.button && !item.button.hidden);
    }
    syncVariantGallery(variant, selectImage, previous) {
      const originals = this.galleryItems.filter(item => item.role === 'original');
      const sizeMatch = String(variant.options[0] || '').match(/(\d+)\s*[x×]\s*(\d+)/);
      const size = sizeMatch ? `${sizeMatch[1]}x${sizeMatch[2]}` : '';
      const artwork = originals.find(item => size && item.size === size) || originals.find(item => item.id === String(variant.artMediaId)) || originals[0];
      originals.forEach(item => { if (item.button) item.button.hidden = item !== artwork; });
      const frame = String(variant.options[1] || '');
      const role = /Utan|unframed|without/i.test(frame) ? 'original' : /Svart|black/i.test(frame) ? 'black' : /Ljus|natural/i.test(frame) ? 'wood' : 'image';
      const active = this.galleryItems.find(item => item.view === this.view);
      const frameChanged = previous && previous.options[1] !== variant.options[1];
      let target = active?.button && !active.button.hidden ? active : this.galleryViews()[0];
      if (selectImage) {
        if (this.galleryVariantId !== undefined && !frameChanged && active?.role === 'original') target = artwork || target;
        else if (frameChanged || !this.galleryVariantId) {
          const attached = this.galleryViews().find(item => item.id === String(variant.mediaId) && (item.role === role || item.role === 'image') && (item.role !== 'original' || item === artwork));
          target = attached || (role === 'original' ? artwork : this.galleryViews().find(item => item.role === role)) || target;
        }
      }
      this.showGallery(target?.view);
    }
    stepGallery(direction) {
      const views = this.galleryViews().map(item => item.view);
      if (!views.length) return;
      this.showGallery(views[(views.indexOf(this.view) + direction + views.length) % views.length]);
    }
    showGallery(view) {
      const item = this.galleryViews().find(media => media.view === view);
      if (!item) return;
      this.view = view;
      this.galleryItems.forEach(media => { media.panel.hidden = media !== item; });
      this.querySelectorAll('[data-gallery]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallery === view)));
      const views = this.galleryViews();
      this.querySelector('[data-gallery-counter]').textContent = `${views.findIndex(media => media === item) + 1} / ${views.length}`;
      this.querySelector('[data-preview-caption]').textContent = item.alt;
    }
    openZoom() {
      const item = this.galleryViews().find(media => media.view === this.view);
      if (item?.role === 'size-guide') {
        const comparison = item.panel.querySelector('.pb30-gallery-sizes');
        if (!comparison) return;
        this.querySelector('[data-zoom-content]').replaceChildren(comparison.cloneNode(true));
        this.querySelector('[data-zoom-caption]').textContent = item.alt;
        this.querySelector('[data-zoom-dialog]').showModal();
        return;
      }
      const source = item?.panel.querySelector('img');
      if (!source) return;
      const image = source.cloneNode(true);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.removeAttribute('loading');
      image.removeAttribute('fetchpriority');
      image.src = item.panel.dataset.zoomUrl || source.src;
      this.querySelector('[data-zoom-content]').replaceChildren(image);
      this.querySelector('[data-zoom-caption]').textContent = item.alt;
      this.querySelector('[data-zoom-dialog]').showModal();
    }
    feedback(message, error = false, cart = false) {
      const box = this.querySelector('[data-feedback]');
      box.hidden = false;
      box.dataset.error = String(error);
      this.querySelector('[data-message]').textContent = message;
      this.querySelector('[data-cart-link]').hidden = !cart;
    }
    syncCartCount(cart) {
      if (!Number.isSafeInteger(cart?.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-cart-count],[data-pbx-cart-count],[data-pb15-cart-count]').forEach(node => { node.textContent = String(cart.item_count);node.hidden = false; });
      document.dispatchEvent(new CustomEvent('postbus:cart-updated', { detail:{ cart } }));
    }
    async refreshCartCount(root) {
      try {
        const response = await fetch(root + 'cart.js', { credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(10000), headers:{ Accept:'application/json' } });
        if (response.ok) this.syncCartCount(await response.json());
      } catch (_) {}
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.uncertain || !this.current?.available) return;
      if (!this.form.reportValidity()) return;
      const properties = {};
      for (const [key, value] of new FormData(this.form)) { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value.trim(); }
      this.busy = true;
      const variant = this.current;
      const button = this.querySelector('[data-add]');
      button.setAttribute('aria-busy', 'true');
      this.controls();
      this.querySelector('[data-feedback]').hidden = true;
      const root = this.state.root.endsWith('/') ? this.state.root : this.state.root + '/';
      window.PostbusDrawer?.begin();
      try {
        const response = await fetch(root + 'cart/add.js', { method:'POST', signal:AbortSignal.timeout(25000), headers:{ 'Content-Type':'application/json','Accept':'application/json' }, body:JSON.stringify({ items:[{ id:variant.id, quantity:1, properties }], sections:['pb28-cart-drawer'], sections_url:this.state.cartUrl || root + 'cart' }) });
        const data = await response.json();
        if (!response.ok) { const message = typeof data.description === 'string' ? data.description : this.state.copy.error; this.feedback(message, true); window.PostbusDrawer?.fail(message); return; }
        this.feedback(this.state.copy.added, false, true);
        this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true, detail:data }));
        this.dispatchEvent(new CustomEvent('pb15:cart-added', { bubbles:true, detail:{ variant,response:data } }));
        if (!window.PostbusDrawer?.isConnected) void this.refreshCartCount(root);
      } catch (_) {
        this.uncertain = true;
        window.PostbusDrawer?.fail(this.state.copy.uncertain);
        this.feedback(this.state.copy.uncertain, true, true);
      } finally {
        this.busy = false;
        button.removeAttribute('aria-busy');
        this.controls();
        if (this.queuedHistory) {
          const queued = this.queuedHistory;
          this.queuedHistory = null;
          this.selectVariant(queued, false);
        }
      }
    }
  }
  customElements.define('pb15-product', Pb15Product);
})();


